import React from 'react';
import { Link } from 'react-router-dom';

const Dashboardhome = () => {
  return (
    <div className="container-fluid">
      <div className="row mt-5">
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="new-pan-application" onClick={() => localStorage.removeItem("newPanId")}>
              <div className="card-header text-center">

                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />


                <Link to="new-pan-application" className="text-color" onClick={() => localStorage.removeItem("newPanId")}>New PAN Application</Link>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="correction-pan-application" onClick={() => localStorage.removeItem("correctionPanId")}>
              <div className="card-header text-center">
                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                <Link to="correction-pan-application" className="text-color" onClick={() => localStorage.removeItem("correctionPanId")}>Correction PAN Application</Link>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="name-publication" onClick={() => localStorage.removeItem("publicationId")}>
              <div className="card-header text-center">

                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />


                <Link to="name-publication" className="text-color" onClick={() => localStorage.removeItem("publicationId")}>Name Publication</Link>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="pan-find" onClick={() => localStorage.removeItem("panFindId")}>
              <div className="card-header text-center">
                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i> <br />
                <Link to="pan-find" className="text-color" onClick={() => localStorage.removeItem("panFindId")}>PAN Find</Link>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="pan-object" onClick={() => localStorage.removeItem("panObjectId")}>
              <div className="card-header text-center">
                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                <Link to="pan-object" className="text-color" onClick={() => localStorage.removeItem("panObjectId")}>PAN Object</Link>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6">
          <div className="card card-default card-mini">
            <Link to="camp-registration">
              <div className="card-header text-center">
                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                <Link to="camp-registration" className="text-color">CAMP Registration</Link>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboardhome;
